import SchemaColumn from './SchemaColumn';
import TableRef from './TableRef';

export default class SchemaTable {
  constructor(
    readonly _schema: string,
    readonly _table: string,
    readonly _columns: SchemaColumn[],
  ) {}

  schema() {
    return this._schema;
  }

  table() {
    return this._table;
  }

  columns() {
    return this._columns;
  }

  toTov() {
    return new TableRef(this.schema(), this.table());
  }

  toString() {
    return `${this.schema()}.${this.table()}`;
  }
}
